import axios from "../../config/axios";

export const getAllEvents = () => axios.get(`events/all`);
export const getAllwebinars = () => axios.get(`zoom/viewAllWebinar`);




export const getEventBookingDetails = eventId =>{
 
  axios.get(`booking/events/${eventId}`);
}

export const getApprovedEventById = eventId =>{
  
  axios.get(`booking/events/${eventId}/APPROVED`);
}

export const getUnApprovedEventById = eventId =>{
 
  axios.get(`booking/events/${eventId}/REJECTED,CANCELED,WAITING,PENDING`);
}
  

export const getEventAttendeesDetails = eventId =>
  axios.get(`attendees/events/${eventId}`);



// WEBPACK FOOTER //
// ./src/services/requestors/event.js